import React from 'react';
import styled from 'styled-components';
import { LucideIcon } from 'lucide-react';

interface SummaryCardProps {
  title: string;
  amount: number;
  color: string;
  icon?: LucideIcon;
}

const Card = styled.div<{ $color: string }>`
  padding: 16px 20px;
  border-right: 3px solid ${props => props.$color};
  flex: 1;
  min-width: 160px;

  @media (max-width: 767px) {
    min-width: 100%;
    padding: 12px 16px;
  }
`;

const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
`;

const CardTitle = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: var(--text-secondary);
`;

const IconWrapper = styled.div<{ $color: string }>`
  color: ${props => props.$color};
  opacity: 0.5;
`;

const CardAmount = styled.div<{ $color: string }>`
  font-size: 26px;
  font-weight: 700;
  color: ${props => props.$color};
  direction: ltr;
  text-align: right;

  @media (max-width: 767px) {
    font-size: 22px;
  }
`;

const SummaryCard: React.FC<SummaryCardProps> = ({ title, amount, color, icon: Icon }) => {
  const formatCurrency = (value: number): string => {
    return `₪${value.toLocaleString('he-IL', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
  };

  return (
    <Card $color={color}>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        {Icon && (
          <IconWrapper $color={color}>
            <Icon size={20} strokeWidth={2} />
          </IconWrapper>
        )}
      </CardHeader>
      <CardAmount $color={color}>{formatCurrency(amount)}</CardAmount>
    </Card>
  );
};

export default SummaryCard;
